import { Measure } from './AbstractMeasure';

export class MeasureType {
  type: string;
  assetList: Array<Measure>;

  constructor(type: string) {
    this.type = type;
    this.assetList = [];
  }
}
